import { noop } from '.';


export const BLOCK_ERROR_MSG = 'BLOCK_MICROPHONE_ERROR';
export const VOICE_SEARCH_PLACEHOLDER = 'IM_LISTENING';
export const INACTIVITY_TEXT = 'VOICE_NOT_RECOGNISED';
export const CURRENT_LANG = 'en-US';
export const VOICE_SESSION_THRESHOLD = 2000;
export const USER_INACTIVITY_THRESHOLD = 4000;
export const LISTENING = 0;
export const VOICE_INACTIVITY = 1;
export const USER_INACTIVITY = 2;
export const API_ERROR = 3;
export const BLOCK_MICROPHONE = 4;
export const defaultSpeech = {
    continuous: true,
    start: noop,
    stop: noop,
    lang: CURRENT_LANG,
    interimResults: true,
    onsoundend: noop,
    onaudioend: noop,
    onspeechend: noop,
    onerror: noop,
    onstop: noop,
    onresult: noop,
    onstart: noop,
  };

